import { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import { useTableStyles } from "./TableStylesContext";

/**
 * The table message container component.
 */
export const MessageContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { styles } = useTableStyles();

  return (
    <div className={classNames(styles.MessageContainer, "message-container")} role="status" aria-live="polite">
      {children}
    </div>
  );
};
